import { useRef } from 'react';
import useComicAudioPlayer from './useComicAudioPlayer.hook';
import Reactplayer from 'react-player';
import useAdvancedCues from '../../useAdvancedCues';
import { Button } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { comicPlayerIcons } from '../ComicPlayer';

export default function ComicAudioPlayer({
  url,
  onReady,
  onStart,
  onProgress,
  onRestart,
  onEnd,
  forceRestart,
  playing = false,
  progressInterval = 100,
  cues,
  onCue,
  seekTo,
  onSeek,
  pageReady,
  playPause,
}) {
  const playerRef = useRef();
  const { state, actions } = useComicAudioPlayer({
    playerRef,
    playing,
    onStart,
    onRestart,
    onProgress,
    forceRestart,
    seekTo,
    url,
  });
  useAdvancedCues({
    currentTime: state.currentTime,
    progressInterval,
    cues,
    onCue,
  });

  return (
    <>
      {state.isBrowser ? (
        <Reactplayer
          ref={playerRef}
          className="react-player"
          url={url}
          playing={playing}
          controls={false}
          progressInterval={progressInterval}
          height="0px"
          width="0px"
          onReady={onReady}
          onStart={actions.onStart}
          onProgress={actions.onProgress}
          onSeek={(time) => {
            if (onSeek) onSeek(time);
          }}
          onDuration={actions.onDuration}
          onEnded={onEnd}
          playbackRate={state.playbackRate}
          onError={(e) => console.error('Error playing comic audio', e)}
        />
      ) : null}
      <Button
        className="play-pause"
        type="link"
        icon={
          pageReady ? (
            playing ? (
              comicPlayerIcons.pause
            ) : (
              comicPlayerIcons.play
            )
          ) : (
            <LoadingOutlined />
          )
        }
        size="small"
        onClick={() => {
          if (playing) {
            playerRef.current.getInternalPlayer().pause();
          } else {
            playerRef.current.getInternalPlayer().play();
          }
          playPause();
        }}
        disabled={!pageReady}
      ></Button>
    </>
  );
}
